import moment from "moment";
import { useLocation } from "react-router-dom";

export function sleep(milliseconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export async function atLeast(millseconds: number, func: () => Promise<void>) {
  const timestamp = moment();
  await func();
  const elapse = moment.duration(moment().diff(timestamp)).milliseconds();
  if (elapse < 1000) {
    await sleep(1000 - elapse);
  }
}

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}